import React from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
} from '@mui/material';

interface Column {
    label: string;
    key?: string;
    align?: 'left' | 'center' | 'right';
    render?: (row: any, index: number) => React.ReactNode;
}

interface StoreTableProps {
    columns: Column[];
    data: any[];
}

const tableSx = {
    boxShadow: 'none',
    border: '1px solid',
    borderColor: 'divider',
};

const headerRowSx = {
    backgroundColor: 'grey.50',
    borderBottom: '2px solid',
    borderColor: 'divider',
};

const headerCellSx = {
    fontWeight: 600,
    color: 'text.primary',
    borderBottom: '2px solid',
    borderColor: 'divider',
    py: 1.5,
};

const bodyRowSx = {
    '&:hover': { backgroundColor: 'grey.50' },
    borderBottom: '1px solid',
    borderColor: 'divider',
};

const bodyCellSx = {
    py: 1.5,
    borderBottom: '1px solid',
    borderColor: 'divider',
};

const StoreTable = ({ columns, data }: StoreTableProps) => (
    <TableContainer component={Paper} sx={tableSx}>
        <Table size="small">
            <TableHead>
                <TableRow sx={headerRowSx}>
                    {columns.map((col, idx) => (
                        <TableCell key={idx} sx={headerCellSx} align={col.align || 'left'}>
                            {col.label}
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
            <TableBody>
                {data.map((row, rowIdx) => (
                    <TableRow key={rowIdx} sx={bodyRowSx}>
                        {columns.map((col, colIdx) => (
                            <TableCell key={colIdx} sx={bodyCellSx} align={col.align || 'left'}>
                                {col.render ? col.render(row, rowIdx) : row[col.key || ''] || '-'}
                            </TableCell>
                        ))}
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>
);

export default StoreTable;
